import React from 'react';
import { object, string, func } from 'prop-types';
import CheckoutCta from '../../../../shared/CheckoutCta';
import LimitedEdition from './LimitedEdition';

const CtaBtn = ({ className, price, onClick }, { general }) => {
    const { isLimitedEdition } = general;

    return (
        <>
            {isLimitedEdition ? <LimitedEdition/> : <CheckoutCta onClick={onClick} className={className} price={price}/>}
        </>
    );
};

CtaBtn.propTypes = {
    className: string,
    price: string,
    onClick: func
};

CtaBtn.contextTypes = {
    general: object
};

export default CtaBtn;
